import axiosInterceptors from "../axiosInterceptor/axiosInterceptor";
import { notificationUrl } from "../config/apiConfig";

export const patientAppointmentReminder = (data) => {
    return axiosInterceptors()
      .get(`${notificationUrl}/patientAppointmentReminder?${data}`)
      .then((res) => res);
  };
